import React from 'react';
import { ErrorMessage, Field, HelperMessage } from '@atlaskit/form';
import { Stack, xcss } from '@atlaskit/primitives';
import { fg } from '@atlassian/jira-feature-gating';
import { useIntl } from '@atlassian/jira-intl';
import { RequestTypeSelect } from '@atlassian/jira-servicedesk-settings-virtual-agent-common/src/ui/request-type-select/main';
import type { RequestTypeOption } from '@atlassian/jira-servicedesk-settings-virtual-agent-common/src/ui/request-type-select/types.tsx';
import messages from './messages';

export const RequestTypeSelector = () => {
	const { formatMessage } = useIntl();

	return (
		<Field<RequestTypeOption | null>
			name="defaultRequestType"
			label={
				fg('virtual_agent_rebrand_to_virtual_service_agent')
					? formatMessage(messages.labelV2)
					: formatMessage(messages.label)
			}
			isRequired
			defaultValue={null}
		>
			{({ fieldProps, error, valid, meta: { touched } }) => (
				<Stack xcss={containerStyles}>
					<RequestTypeSelect {...fieldProps} isInvalid={touched && !valid} />
					{error === 'EMPTY' && (
						<ErrorMessage>{formatMessage(messages.requestTypeNotSelectedError)}</ErrorMessage>
					)}
					{!error && (
						<HelperMessage>
							{fg('virtual_agent_rebrand_to_virtual_service_agent')
								? formatMessage(messages.helperMessageV2)
								: formatMessage(messages.helperMessage)}
						</HelperMessage>
					)}
				</Stack>
			)}
		</Field>
	);
};

const containerStyles = xcss({
	maxWidth: '340px',
});
